import { useEffect, useState } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
// Acromegaly React components
import MDBox from "components/MDBox";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay";
// Acromegaly React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { styled } from "@mui/material/styles";
// Acromegaly React contexts
import { useMaterialUIController } from "context";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Tooltip,
} from "@mui/material";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import TablePaginationActions from "examples/Tables/TablePaginationActions";
import getText from "Translator";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { displayErrorMessage } from "controllers/validation";
import {
  getCapsules,
  updateCapsuleRowNumbers,
  deleteCapsule,
  editCapsules,
} from "controllers/MenuController";
import { displaySuccessMessage } from "controllers/validation";
import { submitCapsule } from "controllers/MenuController";
import config from "../../configs/config";
 

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  td: {
    height: 42,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

let editId;

function CapsuleView(props) {
  const [controller] = useMaterialUIController();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [datas, setDatas] = useState([]);
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [mode, setMode] = useState("new");
  const [search, setSearch] = useState("");
  const [count, setCount] = useState(0);
  const { headline, title } = useParams();

  const navigate = useNavigate();

  const isAssistnt = controller.userRole === "assistant";
  const isAdmin = controller.userRole === "admin";
  const handleDeleteClick = (id) => {
    Swal.fire({
      text: getText("deleteconfirm", controller.lang),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: getText("confirmButtonText", controller.lang),
      cancelButtonText: getText("cancel", controller.lang),
    }).then(async (result) => {
      if (result.value) {
        setLoading(true);
        let data = await deleteCapsule(
          controller.lang,
          { id },
          controller.token
        );
        setLoading(false);
        if (data.success) {
          displaySuccessMessage(
            controller.lang,
            getText("deletesuccessful", controller.lang)
          );
          handleClose();

          getData(rowsPerPage, page + 1, search);
        } else {
          if (data.errorCode === 101) {
            navigate("/authentication/sign-in", { replace: true });
          } else {
            displayErrorMessage(controller.lang, data.message, data.code);
          }
        }
        setLoading(false);
      }
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const submitCapsuleHandler = async () => {
    let newCapsule = {};
    if (mode === "new") {
      newCapsule = {
        title: title,
        rownumber: count + 1,
        lang: controller.lang,
        text,
      };

      setLoading(true);
      let data = await submitCapsule(
        controller.lang,
        newCapsule,
        controller.token
      );
      if (data.success) {
        Swal.fire({
          text: getText("insertsuccesfully", controller.lang),
          position: "top-end",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
        handleClose();

        getData(rowsPerPage, page + 1, search);
      } else {
        if (data.errorCode === 101) {
          navigate("/authentication/sign-in", { replace: true });
        } else {
          console.log(data);
          displayErrorMessage(controller.lang, data.message, data.code);
        }
      }
    } else {
      newCapsule = {
        id: editId,
        title: title,
        lang: controller.lang,
        text,
      };
      let data = await editCapsules(
        controller.lang,
        newCapsule,
        controller.token
      );
      if (data.success) {
        Swal.fire({
          text: getText("editsuccesfully", controller.lang),
          position: "top-end",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
        handleClose();
        getData(rowsPerPage, page + 1, search);
      } else {
        if (data.errorCode === 101) {
          navigate("/authentication/sign-in", { replace: true });
        } else {
          displayErrorMessage(controller.lang, data.message, data.code);
        }
      }
    }

    setLoading(false);
  };
  const handleClose = () => {
    setOpen(false);
    setMode("new");
    setText("");
  };
  const searchHandler = (serachParam) => {
    console.log("serachParam", serachParam);
    getData(rowsPerPage, page + 1, serachParam);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(rowsPerPage, newPage + 1, search);
  };
  const handleDropRows = (droppedItem) => {
    // Ignore drop outside droppable container
    if (!droppedItem.destination || !isAdmin ) return;
    var updatedList = [...datas];
    // Remove dragged item
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    // Add dropped item
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    // Update State
    updatedList.map((item, index) => {
      item.rownumber = rowsPerPage * page + index + 1;
    });
    updateCapsuleRowNumbers(controller.lang, updatedList, controller.token);
    setDatas(updatedList);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    getData(parseInt(event.target.value, 10), 1, search);
  };
  useEffect(() => {
    if (!title || !headline) {
      navigate(-1, { replace: true });
    }
    if (!controller.authenticated) {
      navigate("/authentication/sign-in", { replace: true });
      return;
    }
    if (title) {
      getData(rowsPerPage, 1, "");
    }
  }, [title]);
  const getData = async (rowsPerPagex, pagex, searchx) => {
    try {
      setLoading(true);
      let newData = {
        rowsPerPage: rowsPerPagex,
        page: pagex,
        search: searchx,
        lang: controller.lang,
        title: title,
      };

      let data = await getCapsules(controller.lang, newData, controller.token);
      setLoading(false);
      if (data.success) {
        setDatas(data.data);
        setCount(data.count);
      } else {
        displayErrorMessage(controller.lang, data.message, data.code);
      }
    } catch (err) {
      console.log(err);
      displayErrorMessage(controller.lang);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar
        title={getText("clinics", controller.lang)}
        searchHandler={searchHandler}
        showserch={true}
      />
      <MDBox pb={3}>
        <Card>
          <MDBox>
            <LoadingOverlay
              active={loading}
              spinner
              text={getText("loading", controller.lang)}
            >
              <DragDropContext
                style={{
                  width: "100%",
                }}
                onDragEnd={handleDropRows}
              >
                <Droppable droppableId="list-container">
                  {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      <TableContainer>
                        <Table size="larg" sx={{ minWidth: 500 }}>
                          <TableBody>
                            <TableRow style={{ backgroundColor: "#ccc" }}>
                              <TableCell style={{ width: 60 }} align="center">
                                {getText("row", controller.lang)}
                              </TableCell>
                              <TableCell>
                                {getText("text", controller.lang)}
                              </TableCell>
                              <TableCell align="center" style={{ width: 140 }}>
                              {isAdmin &&<Button
                                  color="secondary"
                                  onClick={() => {
                                    setMode("new");
                                    setText("");
                                    handleClickOpen();
                                  }}
                                >
                                  {getText("addnewitem", controller.lang)}
                                </Button>}
                              </TableCell>
                            </TableRow>

                            {datas.map((row, index) => (
                              <Draggable
                                key={row.id}
                                draggableId={row.id}
                                index={index}
                              >
                                {(provided) => (
                                  <StyledTableRow
                                    key={row.name}
                                    style={{
                                      backgroundColor:
                                        index % 2 === 0 ? "#fff" : "#f2f2f2",
                                    }}
                                    ref={provided.innerRef}
                                    {...provided.dragHandleProps}
                                    {...provided.draggableProps}
                                  >
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      align="center"
                                    >
                                      {row.rownumber}
                                    </TableCell>
                                    <TableCell>
                                      <NavLink
                                        to={
                                          "/page/" +
                                          headline +
                                          "/" +
                                          title +
                                          "/" +
                                          row.id
                                        }
                                         //className={classes.item}
                                        activeClassName="active"
                                        key={index}
                                      >
                                        {row.text}
                                      </NavLink>
                                    </TableCell>
                                    <TableCell align="center">
                                    {isAdmin &&
                                      <div>
                                        <Tooltip
                                          title="ثبت توسط کاربران خارج از اپ"
                                          aria-label="addpage"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <GroupAddIcon
                                            style={{ width: 20, height: 20 }}
                                            color="secondary"
                                            onClick={() => {
                                              navigate(
                                                `/outusers/${headline}/${title}/${row.id}/${row.text}`
                                              );
                                            }}
                                          />
                                        </Tooltip>
                                        <CopyToClipboard text={`${config.appaddress}publicprograms/${headline}/${title}/${row.id}`}>
                                        <Tooltip
                                          title=" لینک عمومی برای کاربران خارج از اپ"
                                          aria-label="addpagepublic"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <MeetingRoomOutlinedIcon
                                            style={{ width: 20, height: 20 }}
                                            color="secondary"
                                             
                                          />
                                        </Tooltip>
                                        </CopyToClipboard>
                                        <Tooltip
                                          title={getText(
                                            "report",
                                            controller.lang
                                          )}
                                          aria-label="edit"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <AssessmentOutlinedIcon
                                            style={{ width: 20, height: 20 }}
                                            color="secondary"
                                            onClick={() => {
                                              console.log(
                                                "/report/" +
                                                  headline +
                                                  "/" +
                                                  row.id
                                              );
                                              navigate(
                                                "/report/" +
                                                  headline +
                                                  "/" +
                                                  row.id
                                              );
                                            }}
                                          />
                                        </Tooltip>
                                        <Tooltip
                                          title={getText(
                                            "edit",
                                            controller.lang
                                          )}
                                          aria-label="edit"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <ModeEditOutlineOutlinedIcon
                                            style={{ width: 20, height: 20 }}
                                            color="secondary"
                                            onClick={() => {
                                              editId = row.id;
                                              setText(row.text);
                                              setMode("edit");
                                              handleClickOpen();
                                            }}
                                          />
                                        </Tooltip>
                                        <Tooltip
                                          title={getText(
                                            "delete",
                                            controller.lang
                                          )}
                                          aria-label="delete"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                        >
                                          <HighlightOffIcon
                                            style={{ width: 20, height: 20 }}
                                            color="primary"
                                            onClick={() => {
                                              handleDeleteClick(row.id);
                                            }}
                                          />
                                        </Tooltip>
                                      </div>}
                                    </TableCell>
                                  </StyledTableRow>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </TableBody>
                          <TableFooter>
                            <TableRow>
                              <TablePagination
                                rowsPerPageOptions={[
                                  5,
                                  10,
                                  25,
                                  { label: "All", value: count },
                                ]}
                                colSpan={8}
                                count={count}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                  inputProps: {
                                    "aria-label": "Rows per page",
                                  },
                                  native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                              />
                            </TableRow>
                          </TableFooter>
                        </Table>
                      </TableContainer>
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </LoadingOverlay>
          </MDBox>
        </Card>
      </MDBox>
      <Dialog
        open={open}
        //onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {mode === "new"
            ? getText("addnewclinic", controller.lang)
            : getText("editclinic", controller.lang)}

          <HighlightOffIcon
            style={{
              width: 20,
              height: 20,
              float: controller.direction == "rtl" ? "left" : "right",
            }}
            color="primary"
            onClick={() => {
              handleClose();
            }}
          />
        </DialogTitle>
        <DialogContent>
          {getText("text", controller.lang)}
          <TextField
            autoFocus
            id="text"
            fullWidth
            variant="outlined"
            style={{ minWidth: 450 }}
            value={text}
            onChange={(event) => {
              setText(event.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="secondary"
            style={{ float: "right", minWidth: 120 }}
          >
            {getText("cancel", controller.lang)}
          </Button>
          <Button active onClick={submitCapsuleHandler} color="primary">
            {mode === "new"
              ? getText("submit", controller.lang)
              : getText("edit", controller.lang)}
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default CapsuleView;
